import React, { useEffect, useState } from "react";
import FormCheckBoxGroup from "./FormCheckBoxGroup";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
// 実績情報取得クエリパラメータ
import {
  setQueryParams,
  setSelectedPlantCode,
  setSelectedProcCode,
  setMachCode,
  setStatus,
  setArrivalDateFrom,
  setArrivalDateTo,
  setShipDateFrom,
  setShipDateTo,
} from "../../redux/queryParamsSlice";
// 通知一覧取得
// import { fetchNotifications } from "../../redux/notificationsSlice";
import { setIsChangeDashboardPlanProcMach } from "../../redux/controllerStateSlice";
import { QueryParams } from "../../models/Po";
import { stringToDate, dateToString } from "../../utils/utils";
import "./Dashboard.css";
import { DatePicker } from "../ui/DatePicker";
import "react-datepicker/dist/react-datepicker.css";

import { MultiMachCodeSelect } from "../ui/MultiMachCodeSelect";
import { SelectChangeEvent } from "@mui/material";

import { PlantCodeSelect } from "../ui/PlantCodeSelect";
import { ProcCodeSelect } from "../ui/ProcCodeSelect";

// 画面上部の入力フォーム
// 入力フォームのデータは、reduxで管理しているqueryParamsに格納（queryParamsは、APIのクエリパラメータ）
const Dashboard: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  // queryParamsはreduxで管理
  // 今後パスパラメータから値を取得し、queryParamsを更新する予定。
  // 加工部のPCでパスパラメータ付きのURLをブックマークしておくことで、毎回入力フォームに値を入力する手間を省く。
  // 入力項目
  const selectedPlantCode = useSelector(
    (state: RootState) => state.queryParams.selectedPlantCode
  );
  const selectedProcCode = useSelector(
    (state: RootState) => state.queryParams.selectedProcCode
  );
  const machCode = useSelector(
    (state: RootState) => state.queryParams.machCode
  );
  const status = useSelector((state: RootState) => state.queryParams.status);
  const arrivalDateFrom = useSelector(
    (state: RootState) => state.queryParams.arrivalDateFrom
  );
  const arrivalDateTo = useSelector(
    (state: RootState) => state.queryParams.arrivalDateTo
  );
  const shipDateFrom = useSelector(
    (state: RootState) => state.queryParams.shipDateFrom
  );
  const shipDateTo = useSelector(
    (state: RootState) => state.queryParams.shipDateTo
  );

  const [isEditPlantCode, setIsEditPlantCode] = useState(false);
  const [isEditProcCode, setIsEditProcCode] = useState(false);
  const [isEditMachCode, setIsEditMachCode] = useState(false);
  const [isEditStatusCheck, setIsEditStatusCheck] = useState(false);
  const [isEditArrivalDateFrom, setIsEditArrivalDateFrom] = useState(false);
  const [isEditArrivalDateTo, setIsEditArrivalDateTo] = useState(false);
  const [isEditShipDateFrom, setIsEditShipDateFrom] = useState(false);
  const [isEditShipDateTo, setIsEditShipDateTo] = useState(false);

  const isChangeDashboardPlanProcMach = useSelector(
    (state: RootState) => state.controllerState.isChangeDashboardPlanProcMach
  );

  // 工場コードの変更を検知
  const handlePlantCodeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    dispatch(setSelectedPlantCode(e.target.value));
    dispatch(setSelectedProcCode(""));
    dispatch(setMachCode([]));
    dispatch(setIsChangeDashboardPlanProcMach(true));
    setIsEditPlantCode(true);
    setIsEditProcCode(true);
    setIsEditMachCode(true);
  };

  // 加工コードの変更を検知
  const handleProcCodeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedProcCode = e.target.value;
    dispatch(setSelectedProcCode(selectedProcCode));
    dispatch(setMachCode([]));
    dispatch(setIsChangeDashboardPlanProcMach(true));
    setIsEditProcCode(true);
    setIsEditMachCode(true);
  };

  // ステータスの変更を検知
  const handleStatusChange = (newStatus: string) => {
    dispatch(setStatus(newStatus));
  };
  const onHandleStatusChange = () => {
    dispatch(setIsChangeDashboardPlanProcMach(true));
    setIsEditStatusCheck(true);
  };

  // 複数選択された機械作業コードを処理
  const handleMachCodeChange = (
    event: SelectChangeEvent<string | string[]>
  ) => {
    const value = event.target.value;
    dispatch(setMachCode(typeof value === "string" ? [value] : value));
    dispatch(setIsChangeDashboardPlanProcMach(true));
    setIsEditMachCode(true);

    // 機械が選択されたので通知を取得
    // dispatch(fetchNotifications(selectedPlantCode, selectedProcCode, typeof value === 'string' ? [value] : value));
  };

  // 出荷日(FROM)の変更を検知
  const handleSetShipDateFrom = (newDate: Date) => {
    dispatch(setShipDateFrom(dateToString(newDate)));
    dispatch(setIsChangeDashboardPlanProcMach(true));
    setIsEditShipDateFrom(true);
  };

  // 出荷日(TO)の変更を検知
  const handleSetShipDateTo = (newDate: Date) => {
    dispatch(setShipDateTo(dateToString(newDate)));
    dispatch(setIsChangeDashboardPlanProcMach(true));
    setIsEditShipDateTo(true);
  };

  // 客先着日(FROM)の変更を検知
  const handleSetArrivalDateFrom = (newDate: Date) => {
    dispatch(setArrivalDateFrom(dateToString(newDate)));
    dispatch(setIsChangeDashboardPlanProcMach(true));
    setIsEditArrivalDateFrom(true);
  };

  // 客先着日(TO)の変更を検知
  const handleSetArrivalDateTo = (newDate: Date) => {
    dispatch(setArrivalDateTo(dateToString(newDate)));
    dispatch(setIsChangeDashboardPlanProcMach(true));
    setIsEditArrivalDateTo(true);
  };

  // queryParamsの状態を更新(redux)
  useEffect(() => {
    const newQueryParams: QueryParams = {
      plant_code: selectedPlantCode,
      proc_code: selectedProcCode,
      mach_code: machCode.join(","),
      status: status,
      arrival_date_from: arrivalDateFrom,
      arrival_date_to: arrivalDateTo,
      ship_date_from: shipDateFrom,
      ship_date_to: shipDateTo,
      page: 1,
      per_page: 300000,
    };
    dispatch(setQueryParams(newQueryParams));
  }, [
    selectedPlantCode,
    selectedProcCode,
    machCode,
    status,
    arrivalDateFrom,
    arrivalDateTo,
    shipDateFrom,
    shipDateTo,
    dispatch,
  ]);

  useEffect(() => {
    if (!isChangeDashboardPlanProcMach) {
      setIsEditPlantCode(false);
      setIsEditProcCode(false);
      setIsEditMachCode(false);
      setIsEditStatusCheck(false);
      setIsEditArrivalDateFrom(false);
      setIsEditArrivalDateTo(false);
      setIsEditShipDateFrom(false);
      setIsEditShipDateTo(false);
    }
  }, [isChangeDashboardPlanProcMach]);

  return (
    <div id="dashboard-container">
      <div id="plant_code-item">
        {/* 工場 */}
        <PlantCodeSelect
          label="工場"
          selectPlantCode={selectedPlantCode}
          handlePlantCodeChange={handlePlantCodeChange}
          isValueChangeState={isEditPlantCode}
        />
      </div>
      <div id="proc_code-item">
        {/* 加工 */}
        <ProcCodeSelect
          label="加工"
          plantCode={selectedPlantCode}
          selectProcCode={selectedProcCode}
          handleProcCodeChange={handleProcCodeChange}
          isValueChangeState={isEditProcCode}
        />
      </div>
      <div id="mach_code-item">
        {/* 機械 */}
        {/* <label htmlFor="mach_code" className="form-label machcode-label">
          機械
        </label> */}
        <MultiMachCodeSelect
          label="機械"
          plantCode={selectedPlantCode}
          procCode={selectedProcCode}
          selectMachCode={machCode}
          handleMachCodeChange={handleMachCodeChange}
          isValueChangeState={isEditMachCode}
        ></MultiMachCodeSelect>
      </div>
      {/* 出荷日 */}
      <div id="ship_date-item">
        <label htmlFor="ship_date_from" className="form-label">
          出荷日
        </label>
        <DatePicker
          id="ship_date_from"
          selected={stringToDate(shipDateFrom)}
          onChange={(date) => date && handleSetShipDateFrom(date)}
          dateFormat="yy/MM/dd"
          calendarStartDay={1}
          isValueChangeState={isEditShipDateFrom}
        />
        <label htmlFor="ship_date_to" className="date-range-label">
          &nbsp;&nbsp;-&nbsp;
        </label>
        <DatePicker
          id="ship_date_to"
          selected={stringToDate(shipDateTo)}
          onChange={(date) => date && handleSetShipDateTo(date)}
          dateFormat="yy/MM/dd"
          calendarStartDay={1}
          isValueChangeState={isEditShipDateTo}
        />
      </div>
      {/* 客先着日 */}
      <div id="arrival_date-item">
        <label htmlFor="arrival_date_to" className="form-label">
          客先着日
        </label>
        <DatePicker
          id="arrival_date_from"
          selected={stringToDate(arrivalDateFrom)}
          onChange={(date) => date && handleSetArrivalDateFrom(date)}
          dateFormat="yy/MM/dd"
          calendarStartDay={1}
          isValueChangeState={isEditArrivalDateFrom}
        />
        <label className="date-range-label">&nbsp;&nbsp;-&nbsp;</label>
        <DatePicker
          id="arrival_date_to"
          selected={stringToDate(arrivalDateTo)}
          onChange={(date) => date && handleSetArrivalDateTo(date)}
          dateFormat="yy/MM/dd"
          calendarStartDay={1}
          isValueChangeState={isEditArrivalDateTo}
        />
      </div>
      {/* ステータス */}
      <div id="status_code-item">
        <FormCheckBoxGroup
          id="status_check"
          label="ステータス"
          options={["未完", "完了"]}
          defaultSelected={["未完"]}
          onSelectedChange={handleStatusChange}
          onHandleChange={onHandleStatusChange}
          isValueChangeState={isEditStatusCheck}
        />
      </div>
    </div>
  );
};

export default Dashboard;
